import React, { useContext, useEffect } from 'react'
import { ThemeContext } from '../../layout/BaseLayout'
import { addVersionFormData } from '../../services/versionHistoryService'

const BulkVersionUpload = () => {

    let toast = useContext(ThemeContext)

    let jsonData = {
        "1.0": {
            "ReleaseDate": "21/08/2023",
            "data": [
                {
                    "header": "1. Office Users",
                    "text": "Admin can create own Office Users who can manage the Admin Portal onbehalf of Admin. Admin can assign particular functionality wise Access Rights to office user. So office user can access only those functionality which assigned.",
                    "iconSrc": "1.0/1-office-users.png",
                    "imageid": "1.0_1_Version",
                    "altName": "Office Users"
                },
                {
                    "header": "2. Security",
                    "text": "Admin can create Multiple Securities according to Exchange wise. Security related settings like Limit Pass, Pending Limit, Weekly Rollover, GTC can be manage from here.0",
                    "iconSrc": "1.0/2-security.png",
                    "imageid": "1.0_2_Version",
                    "altName": "Security"
                },
                {
                    "header": "3. Security Session",
                    "text": "Admin can manage the Session timings for each Security from here. Quote Start, Quote End, Trade Start, Trade End timings for Security can be manage from here. For Trade timings, admin can manage multiple time-slabs.",
                    "iconSrc": "1.0/3-security-session.png",
                    "imageid": "1.0_3_Version",
                    "altName": "Security Session"
                },
                {
                    "header": "4. Master Symbols",
                    "text": "Admin can manage the Master Symbols, which relate to DataFeed can be manage from here. Master Symbols can be manage via Security wise. Master Symbol description can be used for manage Closing File upload.",
                    "iconSrc": "1.0/4-master-symbol.pn",
                    "imageid": "1.0_4_Version",
                    "altName": "Master Symbols"
                },
                {
                    "header": "5. Feeder",
                    "text": "DataFeed related settings can be manage from here. Admin can add new DataFeed details, and assign Securities to it.",
                    "iconSrc": "1.0/5-feeder.png",
                    "imageid": "1.0_5_Version",
                    "altName": "Feeder"
                },
                {
                    "header": "6. Symbols",
                    "text": "Admin can create Symbols from here. The Symbols can be manage Folder wise. Symbol related all details like Security, Source, Digits, Expiry Date, Min, Max, Step, Total etc can be manage from here.",
                    "iconSrc": "1.0/images/1.0/6-symbols.png",
                    "imageid": "1.0_6_Version",
                    "altName": "Symbols"
                },
                {
                    "header": "7. Dealers",
                    "text": "In this screen, all Dealers with hierarchy will be listed. Admin can create/update any Dealer in any hierarchy from here.",
                    "iconSrc": "1.0/7-dealers.png",
                    "imageid": "1.0_7_Version",
                    "altName": "Dealers"
                },
                {
                    "header": "8. Groups",
                    "text": "In this screen, all Groups of hierarchy dealers will be listed. Admin can create/update any Dealer's group in any hierarchy from here.",
                    "iconSrc": "1.0/8-group.png",
                    "imageid": "1.0_8_Version",
                    "altName": "Groups"
                },
                {
                    "header": "9. Clients",
                    "text": "In this screen, admin can search with any ClientId in whole system with any hierarchy and update it.",
                    "iconSrc": "1.0/9-client.png",
                    "imageid": "1.0_9_Version",
                    "altName": "Clients"
                },
                {
                    "header": "10. Upload Closing File",
                    "text": "In this screen, Admin can push any Symbol's closing rate to MasterSymbol. This functionality is manual, for that Admin have to select the Security, MasterSymbol and Closing Rate. Security wise Closing Rate history can be seen from here also.",
                    "iconSrc": "1.0/10-upload-closing-file.png",
                    "imageid": "1.0_10_Version",
                    "altName": "Upload Closing File"
                },
                {
                    "header": "11. Make Balance Zero",
                    "text": "Admin can make balance zero for any Client. Currently have facility to search with any ClientId in whole system with any hierarchy and make balance for zero for that Client.",
                    "iconSrc": "1.0/11-make-balance-zero.png",
                    "imageid": "1.0_11_Version",
                    "altName": "Make Balance Zero"
                },
                {
                    "header": "12. Generate Invoice",
                    "text": "This facility can be used after Rollover completed. Rollover can be performed automatically by system on assigned Day & time. After Rollover completion, admin can generate Invoices.",
                    "iconSrc": "1.0/12-generate-invoice.png",
                    "imageid": "1.0_12_Version",
                    "altName": "1Generate Invoice"
                },
                {
                    "header": "13. Clear History",
                    "text": "Admin can clear all Deals History for any Client. Currently have facility to search with any ClientId in whole system with any hierarchy and clear history for that Client.",
                    "iconSrc": "1.0/13-clear-history.png",
                    "imageid": "1.0_13_Version",
                    "altName": "Clear History"
                },
                {
                    "header": "14. Ban Scripts",
                    "text": "Admin can add Ban Scripts from here. Admin have to select the Security, MasterSymbol and display name. Security wise MasterSymbol get banned from Trading. Ban Scripts are removed automatically at night 12:00 AM from System.",
                    "iconSrc": "1.0/14-ban-script.png",
                    "imageid": "1.0_14_Version",
                    "altName": "Ban Scripts"
                }
            ]
        },
        "1.1": {
            "ReleaseDate": "18/09/2023",
            "data": [
                {
                    "header": "1. New Menus",
                    "text": "Added new options - Data Sync/Backup. This will sync Master Data like Security, Master Symbols, Feeder and Symbols.",
                    "iconSrc": "1.1/1-data-sync.png",
                    "imageid": "1.1_1_Version",
                    "altName": "New Menus"
                },
                {
                    "header": "2. Security",
                    "text": "Added new Column to show number of Master Symbols under that particular security.",
                    "iconSrc": "1.1/2-security.png",
                    "imageid": "1.1_2_Version",
                    "altName": "Security"
                },
                {
                    "header": "3. Master Symbols",
                    "text": "Added new Columns - Symbols (show number of Symbols under that particular Master Symbol) and View Tick. Admin can see the Master Symbol's Feed tick data of that particular day.",
                    "iconSrc": "1.1/3-master-symbol.png",
                    "imageid": "1.1_3_Version",
                    "altName": "Master Symbols"
                },
                {
                    "header": "4. Symbols",
                    "text": "Added new Columns - Client Count (show number of Clients in which this symbol is assigned), Group Count (show number of Groups in which this symbol is assigned) and View Tick. Admin can see the Symbol's Feed tick data of that particular day.",
                    "iconSrc": "1.1/4-symbols.png",
                    "imageid": "1.1_4_Version",
                    "altName": "Symbols"
                },
                {
                    "header": "5. Dealers",
                    "text": "Added new Columns - Client Count (show number of Clients in that dealer), Limit Assigned, Commission Profile Assigned, Symbols Assigned and Access Rights Assigned.",
                    "iconSrc": "1.1/5-dealers.png",
                    "imageid": "1.1_5_Version",
                    "altName": "Dealers"
                },
                {
                    "header": "6. Groups",
                    "text": "Added new Columns - Client Count (show number of Clients in which this group is assigned) and Symbol Path Assigned.",
                    "iconSrc": "1.1/6-groups.png",
                    "imageid": "1.1_6_Version",
                    "altName": "Groups"
                },
                {
                    "header": "7. Clients",
                    "text": "Added new Columns - Group Assigned and Commission Profile Assigned.",
                    "iconSrc": "1.1/7-clients.png",
                    "imageid": "1.1_7_Version",
                    "altName": "Clients"
                },
                {
                    "header": "8. Upload Closing File",
                    "text": "Added new functionality to upload the Closing Rate Excel file for particular security. Closing Rate will be apply to MasterSymbolName or MasterSymbolDescription.",
                    "iconSrc": "1.1/8-upload-closing-file.png",
                    "imageid": "1.1_8_Version",
                    "altName": "Upload Closing File"
                },
                {
                    "header": "9. Make Balance Zero",
                    "text": "Added new functionality to make balance zero for any Client via Dealer's Direct Cients, Dealer's All Hierarchy Clients and All Clients.",
                    "iconSrc": "1.1/9-make-balance-zero.png",
                    "imageid": "1.1_9_Version",
                    "altName": "Make Balance Zero"
                },
                {
                    "header": "10. Generate Invoice",
                    "text": "Added new functionality to show Rollover history. Old history can be deleted from Admin side.",
                    "iconSrc": "1.1/10-generate-invoice.png",
                    "imageid": "1.1_10_Version",
                    "altName": "Generate Invoice"
                },
                {
                    "header": "11. Clear History",
                    "text": "Added new functionality to clear history for any Client via Dealer's Direct Cients, Dealer's All Hierarchy Clients and All Clients.",
                    "iconSrc": "1.1/11-clear-history.png",
                    "imageid": "1.1_11_Version",
                    "altName": "Clear History"
                }
            ]
        },
        "1.2": {
            "ReleaseDate": "27/10/2023",
            "data": [
                {
                    "header": "1. New Menus",
                    "text": "Added new options - DB Backup. This will backup the Database on server.",
                    "iconSrc": "1.2/1-db-backup.png",
                    "imageid": "1.2_1_Version",
                    "altName": "New Menus"
                },
                {
                    "header": "2. Office Users",
                    "text": "Added new Column - Created On (The record created date) - in office users listing page.",
                    "iconSrc": "1.2/2-office-users.png",
                    "imageid": "1.2_2_Version",
                    "altName": "Office Users"
                },
                {
                    "header": "3. Security",
                    "text": "Added new Columns - Created On (The record created date) - in security listing page.",
                    "iconSrc": "1.2/3-security.png",
                    "imageid": "1.2_3_Version",
                    "altName": "Security"
                },
                {
                    "header": "4. Security Session",
                    "text": "Added new functionality to manage multiple time-slabs for Quote timings.",
                    "iconSrc": "1.2/4-security-session.png",
                    "imageid": "1.2_4_Version",
                    "altName": "Security Session"
                },
                {
                    "header": "5. Master Symbols",
                    "text": "Added new Column - Created On (The record created date) - in master symbols listing page.",
                    "iconSrc": "1.2/5-master-symbol.png",
                    "imageid": "1.2_5_Version",
                    "altName": "Master Symbols"
                },
                {
                    "header": "6. Master Symbols - New Contract",
                    "text": "Added new facility to create New Contract related Master Symbols automatically.",
                    "iconSrc": "1.2/6-master-symbol-contract.png",
                    "imageid": "1.2_6_Version",
                    "altName": "1Master Symbols - New Contract"
                },
                {
                    "header": "7. Feeder",
                    "text": "Added new Columns - Created On (The record created date) - in feeder listing page.",
                    "iconSrc": "1.2/7-feeder.png",
                    "imageid": "1.2_7_Version",
                    "altName": "Feeder"
                },
                {
                    "header": "8. Symbols",
                    "text": "Added new Column - Created On (The record created date) - in symbols listing page.",
                    "iconSrc": "1.2/8-symbols.png",
                    "imageid": "1.2_8_Version",
                    "altName": "Symbols"
                },
                {
                    "header": "9. Symbol - New Contract",
                    "text": "Added new facility to create New Contract related Symbols automatically.",
                    "iconSrc": "1.2/9-symbols-new-contract.png",
                    "imageid": "1.2_9_Version",
                    "altName": "Symbol - New Contract"
                },
                {
                    "header": "10. Dealers",
                    "text": "Added new Columns - Created On (The record created date) - in dealers listing page.",
                    "iconSrc": "1.2/10-dealers.png",
                    "imageid": "1.2_10_Version",
                    "altName": "Dealers"
                },
                {
                    "header": "11. Groups",
                    "text": "Added new Columns - Created On (The record created date) - in groups listing page.",
                    "iconSrc": "1.2/11-groups.png",
                    "imageid": "1.2_11_Version",
                    "altName": "Groups"
                },
                {
                    "header": "12. Clients",
                    "text": "Added new Columns - Created On (The record created date) - in clients listing page.",
                    "iconSrc": "1.2/12-clients.png",
                    "imageid": "1.2_12_Version",
                    "altName": "Clients"
                },
                {
                    "header": "13. Upload Closing File",
                    "text": "Added facility to verify uploaded Excel Data. If Data (MasterSymbolName/MasterSymbolDescription) is mismatched, will be highlighted with Red Color.",
                    "iconSrc": "1.2/13-upload-closing.png",
                    "imageid": "1.2_13_Version",
                    "altName": "Upload Closing File"
                },
                {
                    "header": "14. Generate Invoice",
                    "text": "Added facility to view Invoice Generation History. Old history can be deleted from Admin side.",
                    "iconSrc": "1.2/14-generate-invoice.png",
                    "imageid": "1.2_14_Version",
                    "altName": "Generate Invoice"
                }
            ]
        }
    }

    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const extractData = async () => {
        for (const versionId in jsonData) {
            const versionBlock = jsonData[versionId];
            const dataItems = versionBlock.data;

            for (let i = 0; i < dataItems.length; i++) {
                const item = dataItems[i];
                const frmData = new FormData();

                frmData.append("VersionId", versionId);
                frmData.append("header", item?.header);
                frmData.append("text", item?.text);
                frmData.append("altName", item?.altName);
                frmData.append("type", "Admin");
                frmData.append("status", true);

                try {
                    const imageUrl = `/${item.iconSrc}`;
                    const response = await fetch(imageUrl);
                    const blob = await response.blob();
                    frmData.append("file", blob, item.iconSrc.split("/").pop());
                } catch (err) {
                    console.warn(`⚠️ Could not load image: ${item.iconSrc}`, err);
                    continue;
                }

                addVersionFormData(frmData).then((res) => {
                    if (res.isSuccess) {
                        toast.success(res?.successMessage);
                    } else {
                        toast.error(res.exception.message);
                    }
                }).catch(e => {

                })
                await sleep(5000);
            }
        }
    }

    return (
        <div id='tabs'>
            <div className="maintitle-box">
                <div className="w-50 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/connectionencryptdescript.svg"} alt="" />Version Contains</h2>
                </div>
                <div className="w-50 d-inline-block">
                    <div className="float-end ">
                        <div className="d-inline-block mr-3"><i id="feedModuleRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"></i>
                        </div>
                        <button className="addnewbtn mb-0">
                            <i className="fa-solid fa-circle-plus mr-2"></i>Add
                        </button>
                    </div>
                </div>
            </div>
            <button onClick={extractData}>Upload All Versions with Images</button>
        </div>
    )
}

export default BulkVersionUpload